// AppRoutes.jsx
// 로그인 여부에 따라 라우팅을 분기 처리하며 세션 체크 및 공통코드 로딩 hook을 호출한다.

import React, { useState } from "react";
import PasswordPopup from "../comm/passwordPopup/PasswordPopup";
import { useApiUtil } from "../utils/apiUtil";
import { logout } from "../store/userSlice";
import { goLogin } from "../utils/navigation";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../frame/frameLogin";
import MainPage from "../frame/frameMain";
import SearchOrderHistoryWindow from "../category/order/searchOrderHistory/SearchOrderHistoryWindow";
import useSession from "../hooks/useSession";
import useCommCode from "../hooks/useCommCode";
import useCommMsg from "../hooks/useCommMsg";
import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setCommCode,
  setCommMsg,
} from "../store/userSlice";

const AppRoutes = () => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const mustChangePassword = useSelector((state) => String(state.user.userInfo?.INIT_PW ?? "0") === "1");
  const { gfnCallApi } = useApiUtil();

  const commLoaded = useSelector(
    (state) =>
      state.user.commCodeLoaded && state.user.commMsgLoaded
  );

  const dispatch = useDispatch();
  //const [isLoggedIn, setIsLoggedIn] = useState(null);

  // 사용자 세션 및 권한 정보 로드
  useSession();

  const updateCommCode = useCallback(
    (value) => dispatch(setCommCode(value)),
    [dispatch]
  );

  const updateCommMsg = useCallback(
    (value) => dispatch(setCommMsg(value)),
    [dispatch]
  );  

  // 공통 코드 로드
  useCommCode(updateCommCode);
  useCommMsg(updateCommMsg);  
  //useCommCode((value) => dispatch(setCommCode(value)));
  //useCommMsg((value) => dispatch(setCommMsg(value)));

  if (isLoggedIn === null || !commLoaded) return <div>로딩 중...</div>;

  // 초기 비밀번호 사용자는 일반 라우트 자체를 렌더링하지 않는다.
  // 팝업 닫기/ESC/외부 클릭으로 우회하지 못하도록 onClose를 비활성화한다.
  if (isLoggedIn && mustChangePassword) {
    const finishPasswordChange = async () => {
      try {
        await gfnCallApi({ url: "logout", method: "POST", data: {}, showMsg: false });
      } finally {
        localStorage.removeItem("ACCESS_TOKEN");
        sessionStorage.removeItem("ACCESS_TOKEN");
        dispatch(logout());
        goLogin();
      }
    };
    return <PasswordPopup open={true} onClose={() => {}} onSubmit={finishPasswordChange} />;
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isLoggedIn ? (
            <Navigate to="/" />
          ) : (
            <LoginPage />
          )
        }
      />
      <Route
        path="/order-history-popup"
        element={isLoggedIn ? <SearchOrderHistoryWindow /> : <Navigate to="/login" />}
      />
      <Route
        path="*"
        element={isLoggedIn ? <MainPage /> : <Navigate to="/login" />}
      />
    </Routes>
  );
};

export default AppRoutes;
